import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { createTileEpic } from './createTile.epic';
import { duplicateTileEpic } from './duplicateTile.epic';
import { hideDashboardWhenRepriceEpic } from './hideDashboard.epic';
import { loadActiveQuotes } from './loadActiveQuotes.epic';
import { saveActiveQuotes } from './saveActiveQuotes.epic';
import { triggerSaveActiveQuotes } from './triggerSaveActiveQuotes';

export const dashboardEpic = () =>
  withAppCrashIfException(
    'dashboard',
    combineEpics(
      withAppCrashIfException('saveActiveQuotes', saveActiveQuotes()),
      withAppCrashIfException('loadActiveQuotes', loadActiveQuotes()),
      withAppCrashIfException('triggerSaveActiveQuotes', triggerSaveActiveQuotes()),
      withAppCrashIfException('hideDashboardWhenRepriceEpic', hideDashboardWhenRepriceEpic()),
      withAppCrashIfException('createTileEpic', createTileEpic()),
      withAppCrashIfException('duplicateTileEpic', duplicateTileEpic()),
    ),
  );
